<template>
    <div class="container-fluid">
        <!-- all components are loaded, but not displayed, immediately to ensure that backend queries have been made when tab changed -->
        <Loading
            :style="{ display: loaded.generalInfo && loaded.webUsers && loaded.drugSafeUsers ? 'none' : 'block' }"
        />
        <div :style="{ display: loaded.generalInfo && loaded.webUsers && loaded.drugSafeUsers ? 'initial' : 'none' }">
            <!-- TITLE -->
            <div class="mt-2 tabName">
                <h3>
                    {{
                        pharmacy.information
                            ? `${$t(`edit_${pharmacy.information.center_type}`)}: ${pharmacy.information.name}`
                            : ''
                    }}
                </h3>
            </div>
            <!-- "BACK" BUTTON -->
            <div class="row mt-4">
                <div class="col-sm-2">
                    <router-link :to="{ name: 'pharmacy.index' }" class="btn btn-light">
                        {{ $t('back') }}
                    </router-link>
                </div>
            </div>
            <!-- TABS BAR -->
            <div class="d-flex flex-row justify-content-between mt-5 mb-5">
                <div class="d-flex flex-column" :style="{ width: '23%' }">
                    <button
                        :class="tabs.generalInfo ? 'btn btn-dark' : 'btn btn-light'"
                        v-on:click="switchTab('generalInfo')"
                    >
                        {{ $t('general_info') }}
                    </button>
                </div>
                <div class="d-flex flex-column" :style="{ width: '23%' }">
                    <button
                        :class="tabs.webUsers ? 'btn btn-dark' : 'btn btn-light'"
                        v-on:click="switchTab('webUsers')"
                    >
                        {{ $t('web_users') }}
                    </button>
                </div>
                <div class="d-flex flex-column" :style="{ width: '23%' }">
                    <button
                        :class="tabs.drugSafeUsers ? 'btn btn-dark' : 'btn btn-light'"
                        v-on:click="switchTab('drugSafeUsers')"
                    >
                        {{ $t('drugsafe_users') }}
                    </button>
                </div>
                <div class="d-flex flex-column" :style="{ width: '23%' }">
                    <button
                        :class="tabs.drugSafeStructure ? 'btn btn-dark' : 'btn btn-light'"
                        v-on:click="switchTab('drugSafeStructure')"
                    >
                        {{ $t('drugsafe_structure') }}
                    </button>
                </div>
            </div>
            <!-- TAB: PHARMACY INFO -->
            <BasicInfo
                v-if="loaded.generalInfo"
                :style="{ display: tabs.generalInfo ? 'initial' : 'none' }"
                :pharmacy="pharmacy"
                :pharmacyWebUsers="pharmacyWebUsers"
            />
            <!-- TAB: WEB USERS -->
            <div :style="{ display: tabs.webUsers ? 'initial' : 'none' }">
                <div class="row mt-4 mb-3">
                    <div class="col-sm-5">
                        <router-link :to="{ name: 'user.create', params: { pharmacyId } }" class="btn btn-success">
                            {{ $t('create_user') }}
                        </router-link>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col">
                        <WebUserIndex
                            v-if="loaded.generalInfo"
                            :style="{ display: tabs.webUsers ? 'initial' : 'none' }"
                            @loaded="setLoaded('webUsers')"
                            :pharmacyWebUsers="pharmacyWebUsers"
                        />
                    </div>
                </div>
            </div>
            <!-- TAB: DRUGSAFE USERS -->
            <div :style="{ display: tabs.drugSafeUsers ? 'initial' : 'none' }">
                <div class="row mt-4 mb-3">
                    <div class="col-sm-5">
                        <router-link :to="{ name: 'user.create', params: { pharmacyId } }" class="btn btn-success">
                            {{ $t('create_user') }}
                        </router-link>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col">
                        <DrugSafeUserIndex
                            :style="{ display: tabs.drugSafeUsers ? 'initial' : 'none' }"
                            @loaded="setLoaded('drugSafeUsers')"
                            :pharmacyId="pharmacyId"
                        />
                    </div>
                </div>
            </div>
            <!-- TAB: DRUGSAFE STRUCTURE -->
            <div v-if="tabs.drugSafeStructure">
                <div class="row">
                    <div class="col-9">
                        <div class="mt-5 safe"
                             v-for="(box, idx) in pharmacy.box"
                             v-bind:key="idx">
                            <label> {{idx}}</label>
                            <ul class="door" v-if="idx === 0">
                                <li class="panel screen" v-bind:key="'0-0'" :id="'0-0'"><span></span></li>
                                <li
                                    v-for="(locker, index) in box"
                                    v-bind:key="idx + '-' + (index + 1)"
                                    class="panel"
                                    :class="'type' + locker"
                                    :id="idx + '-' + (index + 1)"
                                >
                                    <span></span>
                                </li>
                            </ul>

                            <ul class="door" v-if="idx > 0">
                                <li
                                    v-for="(locker, index) in box"
                                    v-bind:key="idx + '-' + index"
                                    class="panel"
                                    :class="'type' + locker"
                                    :id="idx + '-' + index"
                                >
                                    <span></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="row">
                            <div class="col-12">
                                <input
                                    type="button"
                                    v-on:click="() => addModule()"
                                    class="btn btn-info"
                                    :value="$t('add_module')"
                                />
                            </div>
                            <div class="col-12">
                                <div class="form-group" v-if="added_modules.length > 0">
                                    <label for="additionalModule">{{ $t('additional_modules') }}</label>
                                    <div v-for="(addMod, index) in added_modules" v-bind:key="index">
                                        <select id="additionalModule" class="form-control" v-model="added_modules[index]">
                                            <option value="big_no_fridge">{{ $t('big_no_fridge') }}</option>
                                            <option value="big_fridge">{{ $t('big_with_fridge') }}</option>
                                            <option value="small_no_fridge">{{ $t('small_no_fridge') }}</option>
                                            <option value="small_fridge">{{ $t('small_with_fridge') }}</option>
                                        </select>
                                    </div>
                                    <input
                                        type="button"
                                        v-on:click="() => saveAddedModules()"
                                        class="btn btn-success"
                                        :value="$t('save')"
                                    />
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-12">
                                <input
                                    type="button"
                                    v-on:click="() => removeModule()"
                                    class="btn btn-danger"
                                    :value="$t('remove_module')"
                                />
                                </div>
                            <div class="col-12">
                                <div id="forModuleRemove" class="form-group" style="display: none">
                                    <label for="removeModule">{{ $t('choose_module_to_remove') }}</label>
                                    <div>
                                        <select id="removeModule" class="form-control" v-model="remove_module">
                                            <option
                                                v-for="(addMod, index) in pharmacy.box"
                                                v-bind:key="index"
                                                :value="index">{{ index }}</option>
                                        </select>
                                    </div>
                                    <input
                                        type="button"
                                        v-on:click="() => saveRemovedModule()"
                                        class="btn btn-danger"
                                        :value="$t('remove')"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '@/views/partial/Loading';
import BasicInfo from './BasicInfo';
import DrugSafeUserIndex from '@/components/users/drugSafe/DrugSafeUserIndex';
import WebUserIndex from '@/components/users/web/WebUserIndex';
import {
    createPharmacy,
    getPharmacy,
    getWebUsersForPharmacy,
    handleAxiosError,
    updateDrugSafeStructure
} from '@/services/axiosService';
import { mapState } from 'vuex';
import { getLocalDate } from '@/services/dateService';

export default {
    components: {
        BasicInfo,
        DrugSafeUserIndex,
        Loading,
        WebUserIndex
    },
    data() {
        return {
            getLocalDate,
            loaded: {
                generalInfo: false,
                drugSafeUsers: false,
                webUsers: false
            },
            pharmacy: {},
            pharmacyId: this.$route.params.id || null,
            pharmacyWebUsers: null,
            success: false,
            tabs: {
                generalInfo: true,
                drugSafeUsers: false,
                drugSafeStructure: false,
                webUsers: false
            },
            added_modules: [],
            remove_module: null
        };
    },
    computed: {
        ...mapState('account', ['status', 'user'])
    },
    async created() {
        // get pharmacy and its web users
        await this.getPharmacy();
        await this.getWebUsersForPharmacy();
        this.setLoaded('generalInfo');
    },
    methods: {
        // get pharmacy
        async getPharmacy() {
            try {
                this.pharmacy = await getPharmacy(this.pharmacyId);
                this.pharmacy.box[0].splice(0, 1); // format locker structure value
            } catch (error) {
                handleAxiosError(error);
            }
        },
        // get pharmacy's web users
        async getWebUsersForPharmacy() {
            try {
                this.pharmacyWebUsers = await getWebUsersForPharmacy(this.pharmacy.id);
            } catch (error) {
                handleAxiosError(error);
            }
        },
        // set page loaded
        setLoaded(component) {
            this.loaded[component] = true;
        },
        // handle tab switch
        switchTab(tabName) {
            for (let tab in this.tabs) {
                this.tabs[tab] = tab == tabName;
            }
        },
        addModule() {
            this.added_modules.push('big_no_fridge')
        },
        async saveAddedModules() {
            const result = await updateDrugSafeStructure(this.pharmacy.id, {
                update: 'add',
                modules: this.added_modules
            });
            this.$toastr.s(this.$t('pharmacy_updated'));
            this.added_modules = [];
            this.pharmacy.box = result.box;
        },
        removeModule() {
            document.getElementById('forModuleRemove').style.display = 'block'
        },
        async saveRemovedModule() {
            try {
                const result = await updateDrugSafeStructure(this.pharmacy.id, {
                    update: 'remove',
                    module: this.remove_module
                });
                this.$toastr.s(this.$t('pharmacy_updated'));
                this.remove_module = null;
                this.pharmacy.box = result.box;
            } catch (error) {
                handleAxiosError(error);
            }
        }
    }
};
</script>
<style scoped>
.btn:focus {
    outline: none;
    box-shadow: none;
}
</style>
